import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormFields } from '../create-progress/form-fields';
import { TemplateApiService } from '../../core/template';
import { SiteService } from '../../core/site';
import { CreateTemplateResponse } from '../../core/template/template';

@Injectable()
export class CreateNewTemplateService {
  form$$: BehaviorSubject<FormFields> = new BehaviorSubject<FormFields>(undefined);

  constructor(private templateService: TemplateApiService, private siteService: SiteService, private router: Router) {}

  navigateTo(url: string): void {
    this.router.navigateByUrl(url);
  }

  setFormFields(form: FormFields): void {
    this.form$$.next(form);
  }

  createTemplate(partnerId: string, parentTemplateId = ''): Observable<CreateTemplateResponse> {
    const createTemplateMessage = this.form$$.value.buildTemplateCreateMessage(partnerId, parentTemplateId);
    return this.templateService.createTemplate(createTemplateMessage);
  }
}
